<template>
  <div>
    <NavBar />
    <div class="container-fluid mb-5">
      <b-overlay :show="loadingRestHome" opacity="0.99">
        <v-card class="p-5 mb-2">
          <div class="row">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fa fa-arrow-left mr-1"></i> VOLTAR
            </v-btn>
            <h1 class="title-page pl-2 mt-2">{{ fantasy_name }}</h1>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <b-overlay :show="loadingCreateLogo" opacity="0.99">
                <div v-show="logo != null" class="text-center">
                  <img
                    :src="logo"
                    class="img-fluid rounded mx-auto d-block mb-5"
                    width="200px"
                    height="auto"
                  />
                  <v-btn
                    v-if="permissions.rest_home.edit"
                    class="btn-del-img"
                    small
                    v-confirm="{
                      html: true,
                      loader: false,
                      ok: (dialog) => deleteLogo(),
                      cancel: () => {},
                      message: 'Deseja realmente apagar a logo?',
                      okText: 'Confirmar',
                      cancelText: 'Cancelar',
                    }"
                    ><i class="fa fa-trash"></i
                  ></v-btn>
                  <p class="mb-0 mt-3 text-info-img">
                    Tamanho máximo <strong>2MB</strong>
                  </p>
                  <p class="text-info-img">
                    Formatos: <strong>JPG, JPEG, PJPEG</strong> e
                    <strong>PNG</strong>
                  </p>
                </div>

                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <input
                    v-if="permissions.rest_home.edit"
                    type="file"
                    @change="createLogo($event)"
                    class="form-control-file"
                  />
                </div>
                <ErrorsMessages :errors="errors" />
              </b-overlay>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
              <form v-on:submit="update" method="post">
                <div class="row">
                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="Plano" />
                    <select disabled v-model="plan_id" class="form-control">
                      <option
                        v-for="plan in plans"
                        :key="plan.id"
                        :value="plan.id"
                      >
                        {{ String(plan.description).toUpperCase() }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="Razão social" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="name"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Nome fantasia</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="fantasy_name"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="CNPJ" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-mask="'##.###.###/####-##'"
                      v-model="cnpj"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="IE" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="ie"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="1º Telefone" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-mask="'(##) # ####-####'"
                      v-model="first_phone"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>2º Telefone</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-mask="'(##) # ####-####'"
                      v-model="second_phone"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-10 col-9 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="Endereço" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="address"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-3 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="Nº" />
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="num_address"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Complemento</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="complement"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Bairro</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="neighborhood"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>CEP</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-mask="'#####-###'"
                      v-model="cep"
                      class="form-control"
                      @keyup="handleSearchCEP"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Cidade</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="city"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Estado</label>
                    <select
                      :disabled="!permissions.rest_home.edit"
                      v-model="uf_id"
                      class="form-control"
                    >
                      <option value>Selecione...</option>
                      <option v-for="uf in ufs" :key="uf.id" :value="uf.id">
                        {{ uf.name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>Região</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="region"
                      class="form-control"
                    />
                  </div>

                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="Status" />
                    <div class="input-group">
                      <select
                        :disabled="!permissions.rest_home.edit"
                        v-model="status_rest_home_id"
                        class="form-control"
                      >
                        <option
                          v-for="status in status_rest_home"
                          :key="status.id"
                          :value="status.id"
                        >
                          {{ String(status.name).toUpperCase() }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <LabelRequiredField label="APENAS FINANCEIRO" />
                    <select
                      v-model="finance"
                      class="form-control"
                      @change="handleChangeFinance"
                    >
                      <option :value="0">NÃO</option>
                      <option :value="1">SIM</option>
                    </select>
                  </div>

                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>LATITUDE</label>
                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="latitude"
                      class="form-control"
                    />
                  </div>

                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <label>LONGITUDE</label>

                    <input
                      :disabled="!permissions.rest_home.edit"
                      type="text"
                      v-model="longitude"
                      class="form-control"
                    />
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-0 pb-0 mt-0 pb-0"
                  >
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div class="col-md-12 text-right mb-0 pb-0 mt-0 pb-0">
                    <v-btn
                      v-if="permissions.rest_home.edit"
                      :disabled="loadingUpdate"
                      type="submit"
                      class="btn-save"
                    >
                      <i class="fa fa-save mr-1"></i>
                      {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-0 pb-0 mt-0 pb-0"
            >
              <h6>
                <span class="text-muted">Criação:</span>
                {{ formatDate(restHome.created_at) }}
              </h6>
              <h6>
                <span class="text-muted">Última alteração:</span>
                {{ formatDate(restHome.updated_at) }}
              </h6>
            </div>
          </div>
        </v-card>

        <v-card class="p-5">
          <b-tabs
            nav-class
            active-nav-item-class="font-weight-bold text-white"
            vertical
            pills
            card
            lazy
            no-fade
            v-model="tab"
          >
            <b-tab title="Implantação" active>
              <RestHomeDeployment :rest_home_id="id" />
            </b-tab>
            <b-tab title="Dispositivos">
              <RestHomeDevices :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Permissões">
              <RestHomePermissions :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Grupos de usuário">
              <RestHomeUserGroup :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Perfis de usuário">
              <RestHomeUserProfile :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Usuários">
              <RestHomeUser :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Residentes">
              <RestHomeResident :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Cobrança">
              <RestHomeCharge :id="id" :plan_id="plan_id" />
            </b-tab>
            <b-tab title="Geolocalização">
              <RestHomeGeolocation :id="id" />
            </b-tab>
          </b-tabs>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";

import RestHomeDeployment from "../templates/RestHome/Deployment";
import RestHomeDevices from "../templates/RestHome/Devices";
import RestHomePermissions from "../templates/RestHome/Permissions";
import RestHomeUserGroup from "../templates/RestHome/UserGroup";
import RestHomeUserProfile from "../templates/RestHome/UserProfile";
import RestHomeUser from "../templates/RestHome/User";
import RestHomeResident from "../templates/RestHome/Resident";
import RestHomeCharge from "../templates/RestHome/Charge";
import RestHomeGeolocation from "../templates/RestHome/Geolocation";

import routes from "../routes";
import api from "../services/api";
import apiCep from "../services/apiCep";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "RestHome",

  components: {
    NavBar,
    LabelRequiredField,
    ErrorsMessages,
    RestHomeDeployment,
    RestHomeDevices,
    RestHomePermissions,
    RestHomeUserGroup,
    RestHomeUserProfile,
    RestHomeUser,
    RestHomeResident,
    RestHomeCharge,
    RestHomeGeolocation,
  },

  data() {
    return {
      tab: 0,

      finance: 0,

      permissions: {},

      errors: [],

      restHome: {},

      ufs: [],

      plans: [],

      status_rest_home: [],

      id: "",

      plan_id: "",

      status_rest_home_id: "",

      uf_id: "",

      name: "",

      fantasy_name: "",

      email: "",

      password: "",

      confirm_password: "",

      cnpj: "",

      ie: "",

      address: "",

      num_address: "",

      complement: "",

      neighborhood: "",

      first_phone: "",

      second_phone: "",

      cep: "",

      city: "",

      region: "",

      logo: null,

      loadingUpdate: false,

      loadingUpdatePassword: false,

      loadingCreateLogo: false,

      status_name: "",

      loadingRestHome: true,

      longitude: "",

      latitude: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,

    handleSearchCEP: async function (e) {
      let _cep = e.target.value;

      if (_cep) {
        if (_cep.length == 9) {
          const response = await apiCep.get(`/${_cep}/json`);

          if (response.data.erro) {
            toast("CEP inválido", "error");
          } else {
            const { cep, logradouro, bairro, complemento, uf, localidade } =
              response.data;

            const { ufs } = this;

            ufs.map((u) => {
              if (u.initials == uf) {
                this.uf_id = u.id;
              }
            });

            this.cep = cep;
            this.address = logradouro;
            this.neighborhood = bairro;
            this.city = localidade;
            this.complement = complemento;
          }
        }
      }
    },

    async retrieve() {
      this.permissions = adminData().permissions;

      const { id } = routes.history.current.params;

      if (!id) {
        routes.push({ name: "clients" });
        return;
      }

      this.id = id;

      await this.getRestHome(id);
      await this.getPlans();
      await this.getStatusRestHome();
      await this.getUfs();

      const { tab } = routes.history.current.query;

      if (tab) {
        this.tab = {
          charge: 7,
        }[tab];
      }
    },

    async handleChangeFinance() {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, finance } = this;

        let params = { id, finance };

        const response = await api.put(
          "/admin/rest-home/finance/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.getRestHome(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPlans() {
      try {
        const response = await api.get("/admin/plan/all");

        const { plans } = response.data;

        this.plans = plans;
      } catch (error) {
        console.log(error);
      }
    },

    async getStatusRestHome() {
      try {
        const response = await api.get("/admin/rest-home/status/all");

        const { status } = response.data;

        this.status_rest_home = status;
      } catch (error) {
        console.log(error);
      }
    },

    async getUfs() {
      try {
        const response = await api.get("/ufs");

        const { ufs } = response.data;

        this.ufs = ufs;
      } catch (error) {
        console.log(error);
      }
    },

    async getRestHome(id) {
      try {
        this.loadingRestHome = true;

        const response = await api.get("/admin/rest-home/get", {
          params: { id },
        });

        const { restHome } = response.data;

        this.restHome = restHome;
        this.plan_id = restHome.plan_id;
        this.name = restHome.name;
        this.status_rest_home_id = restHome.status_rest_home_id;
        this.uf_id = restHome.uf_id;
        this.name = restHome.name;
        this.fantasy_name = restHome.fantasy_name;
        this.email = restHome.email;
        this.cnpj = restHome.cnpj;
        this.ie = restHome.ie;
        this.address = restHome.address;
        this.num_address = restHome.num_address;
        this.complement = restHome.complement;
        this.neighborhood = restHome.neighborhood;
        this.first_phone = restHome.first_phone;
        this.second_phone = restHome.second_phone;
        this.cep = restHome.cep;
        this.city = restHome.city;
        this.region = restHome.region;
        this.logo = restHome.logo_url;
        this.finance = restHome.finance;
        this.loadingRestHome = false;
        this.latitude = restHome.latitude;
        this.longitude = restHome.longitude;
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const {
          id,
          plan_id,
          status_rest_home_id,
          uf_id,
          name,
          fantasy_name,
          email,
          cnpj,
          ie,
          address,
          num_address,
          complement,
          neighborhood,
          first_phone,
          second_phone,
          cep,
          city,
          region,
          latitude,
          longitude,
        } = this;

        let params = {
          id,
          plan_id,
          status_rest_home_id,
          uf_id,
          name,
          fantasy_name,
          email,
          cnpj,
          ie,
          address,
          num_address,
          complement,
          neighborhood,
          first_phone,
          second_phone,
          cep,
          city,
          region,
          latitude,
          longitude,
        };

        const response = await api.put("/admin/rest-home/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getRestHome(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createLogo(event) {
      try {
        event.preventDefault();

        this.loadingCreateLogo = true;

        const { id } = this;

        const formData = new FormData();

        let logo = event.target.files[0];

        if (!logo) {
          this.loadingCreateLogo = false;
          return toast("Informe a logo", "error");
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
        ];

        if (!allowedMimes.includes(logo.type)) {
          this.loadingCreateLogo = false;
          return toast("Formato de arquivo inválido", "error");
        }

        var limitSize = 2 * 1024 * 1024;

        if (logo.size > limitSize) {
          this.loadingCreateLogo = false;
          return toast("Suportado até 2MB", "error");
        }

        formData.append("id", id);
        formData.append("logo", logo, logo.name);

        const response = await api.post("/admin/logo/create", formData);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getRestHome(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loadingCreateLogo = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteLogo() {
      try {
        this.loadingCreateLogo = true;

        const { id } = this;

        let data = { id };

        const response = await api.delete("/admin/logo/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getRestHome(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreateLogo = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToBack() {
      routes.push({ name: "clients" });
    },
  },
};
</script>

<style>
.text-info-img {
  font-size: 12px;
}

.btn-del-img {
  background-color: brown !important;
  color: #fff !important;
  min-width: 30px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 20px !important;
  margin-top: -25px;
}

.btn-return {
  border-radius: 4px !important;
  background-color: #546a79 !important;
  color: #fff !important;
}

.btn-add {
  background-color: #2a937f !important;
  color: #fff !important;
  border-radius: 4px !important;
  font-weight: 500;
}
.btn-save {
  background-color: #148a14 !important;
  color: #fff !important;
  border-radius: 4px !important;
}

.btn-alter {
  background-color: #0075c8 !important;
  color: #fff !important;
  border-radius: 4px !important;
  font-weight: 500;
}
</style>